<template>
  <div id="app">
    <div class="container">
      <header>
        <h1>🎨 GIF 工具箱</h1>
        <p class="subtitle">GIF 全能工具箱</p>
      </header>

      <div class="tabs-container">
        <div class="tabs-row">
          <button
            class="tab"
            :class="{ active: currentTab === 'compose' }"
            @click="currentTab = 'compose'"
          >
            GIF合成
          </button>
          <button
            class="tab"
            :class="{ active: currentTab === 'split' }"
            @click="currentTab = 'split'"
          >
            GIF拆分
          </button>
          <button
            class="tab"
            :class="{ active: currentTab === 'compress' }"
            @click="currentTab = 'compress'"
          >
            GIF压缩
          </button>
          <button
            class="tab"
            :class="{ active: currentTab === 'crop' }"
            @click="currentTab = 'crop'"
          >
            GIF裁剪
          </button>
        </div>
        <div class="tabs-row">
          <button
            class="tab"
            :class="{ active: currentTab === 'text' }"
            @click="currentTab = 'text'"
          >
            GIF加字
          </button>
          <button
            class="tab"
            :class="{ active: currentTab === 'merge' }"
            @click="currentTab = 'merge'"
          >
            GIF合并
          </button>
          <button
            class="tab"
            :class="{ active: currentTab === 'filter' }"
            @click="currentTab = 'filter'"
          >
            GIF滤镜
          </button>
          <button
            class="tab"
            :class="{ active: currentTab === 'video' }"
            @click="currentTab = 'video'"
          >
            视频转GIF
          </button>
        </div>
      </div>

      <div class="content">
        <section
          class="tab-content"
          :class="{ active: currentTab === 'compose' }"
        >
          <imgs-to-gif />
        </section>

        <section
          class="tab-content"
          :class="{ active: currentTab === 'split' }"
        >
          <gif-to-imgs />
        </section>

        <section
          class="tab-content"
          :class="{ active: currentTab === 'crop' }"
        >
          <gif-crop />
        </section>

        <section
          class="tab-content"
          :class="{ active: currentTab === 'compress' }"
        >
          <gif-compress />
        </section>

        <section
          class="tab-content"
          :class="{ active: currentTab === 'text' }"
        >
          <gif-text />
        </section>

        <section
          class="tab-content"
          :class="{ active: currentTab === 'merge' }"
        >
          <gif-merge />
        </section>

        <section
          class="tab-content"
          :class="{ active: currentTab === 'filter' }"
        >
          <gif-filter />
        </section>

        <section
          class="tab-content"
          :class="{ active: currentTab === 'video' }"
        >
          <video-to-gif />
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import ImgsToGif from './imgsToGif.vue'
import VideoToGif from './videoToGif.vue'
import GifToImgs from './gifToImgs.vue'
import GifCrop from './gifCrop.vue'
import GifCompress from './gifCompress.vue'
import GifText from './gifText.vue'
import GifMerge from './gifMerge.vue'
import GifFilter from './gifFilter.vue'
import { Button, Toast } from 'vant'
import 'gif.js'

Vue.use(Toast)
Vue.use(Button)

export default {
  name: 'App',
  components: {
    ImgsToGif,
    VideoToGif,
    GifToImgs,
    GifCrop,
    GifCompress,
    GifText,
    GifMerge,
    GifFilter
  },
  data () {
    return {
      currentTab: 'compose'
    }
  }
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  min-height: 100vh;
  padding: 16px;
  color: #333;
}

#app {
  min-height: 100vh;
}

.container {
  max-width: 500px;
  margin: 0 auto;
}

header {
  text-align: center;
  color: white;
  margin-bottom: 24px;
  padding-top: 20px;
}

h1 {
  font-size: 28px;
  font-weight: 700;
  margin-bottom: 8px;
}

.subtitle {
  font-size: 14px;
  opacity: 0.9;
}

.tabs-container {
  background: white;
  border-radius: 12px;
  padding: 6px;
  margin-bottom: 16px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.tabs-row {
  display: flex;
  gap: 4px;
}

.tabs-row:first-child {
  margin-bottom: 4px;
}

.tab {
  flex: 1;
  padding: 10px 4px;
  text-align: center;
  border-radius: 8px;
  cursor: pointer;
  font-size: 13px;
  font-weight: 500;
  transition: all 0.3s;
  border: none;
  background: #f5f5f5;
  color: #666;
  white-space: nowrap;
}

.tab:hover {
  background: #e8e8ff;
}

.tab.active {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
}

.content {
  background: white;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.tab-content {
  display: none;
}

.tab-content.active {
  display: block;
}
</style>
